import { render, staticRenderFns } from "./app-business-comp.vue?vue&type=template&id=3a9a890b&scoped=true&"
import script from "./js/app-business-comp.js?vue&type=script&lang=js&"
export * from "./js/app-business-comp.js?vue&type=script&lang=js&"
import style0 from "./app-business-comp.vue?vue&type=style&index=0&id=3a9a890b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9a890b",
  null
  
)

export default component.exports